<template>
  <div class="grid-layout">
    <div class="grid-visual" @click="toDetail">
      <img class="visual-pic" :src="visualPic" alt="智慧配电网平台" />
      <div class="visual-mask"></div>
      <div class="visual-metrics">
        <div v-for="item in metrics" :key="item.label" class="metric-item">
          <div class="metric-value">{{ item.value }}</div>
          <div class="metric-label">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <div class="grid-capabilities">
      <div
        v-for="item in capabilities"
        :key="item.title"
        class="capability-item"
        @click="toDetail"
      >
        <span class="capability-icon">
          <operation-icon :name="item.icon"></operation-icon>
        </span>
        <div class="capability-copy">
          <div class="capability-title">{{ item.title }}</div>
          <div class="capability-text">{{ item.text }}</div>
        </div>
        <span class="capability-arrow" aria-hidden="true">
          <svg viewBox="0 0 16 16" fill="none">
            <path d="M6 4.5L9.5 8 6 11.5" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import OperationIcon from "../../zhiHuiYunWei/cpns/operation-icon.vue";

export default {
  name: "HomePartGrid",
  components: { OperationIcon },
  data() {
    return {
      visualPic: require("../../shuZiDianLi/images/elecNet/platform-dashboard.webp"),
      metrics: [
        { value: "75%", label: "数据治理时间减少" },
        { value: "3倍", label: "日常工作效率提升" },
        { value: "2名", label: "减少重复运维投入" },
        { value: "80+万元", label: "项目预算优化" },
      ],
      capabilities: [
        {
          title: "X-Mate 智能体平台",
          text: "知识库、技能库与智能体一体编排，让任务持续自动运行",
          icon: "aggregate",
        },
        {
          title: "配网业务综合管控",
          text: "设备、运行、检修、抢修与工程管理全流程贯通",
          icon: "multi-grid",
        },
        {
          title: "网架分析与技术研究",
          text: "网架拓扑成图、指标计算诊断与沙盘模拟规划",
          icon: "data",
        },
        {
          title: "自动化分析应用",
          text: "重复的数据稽查与分析工作交给系统自动执行",
          icon: "efficiency",
        },
        {
          title: "AI 电力业务垂直应用",
          text: "自然语言查询数据、自动生成报表、智能校核合规",
          icon: "shield",
        },
      ],
    };
  },
  methods: {
    toDetail() {
      if (this.$route.path != "/szdl") {
        this.$router.push({ path: "/szdl" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-layout {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 160px;
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  gap: 48px;
}

.grid-visual {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  cursor: pointer;
  box-shadow: 0 16px 40px rgba(18, 68, 145, 0.16);

  &:hover .visual-pic {
    transform: scale(1.04);
  }
}

.visual-pic {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.5s;
}

.visual-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(4, 27, 70, 0) 42%,
    rgba(4, 27, 70, 0.68) 72%,
    rgba(3, 22, 58, 0.92) 100%
  );
}

.visual-metrics {
  position: absolute;
  right: 34px;
  bottom: 34px;
  left: 34px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  color: #ffffff;
}

.metric-item {
  min-width: 0;
  padding-left: 14px;
  border-left: 2px solid rgba(122, 172, 255, 0.85);
}

.metric-value {
  margin-bottom: 8px;
  font-size: 26px;
  font-weight: bold;
}

.metric-label {
  color: rgba(255, 255, 255, 0.76);
  font-size: 13px;
  line-height: 20px;
}

.grid-capabilities {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.capability-item {
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  padding: 0 26px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #e4ebf5;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s;

  &:hover {
    transform: translateX(6px);
    border-color: #a9c8ff;
    box-shadow: 0 14px 30px rgba(18, 68, 145, 0.12);

    .capability-icon {
      color: #ffffff;
      background: linear-gradient(135deg, #1f63ea, #5c91ff);
    }

    .capability-arrow {
      color: #ffffff;
      background: #1f63ea;
    }
  }
}

.capability-icon {
  width: 54px;
  height: 54px;
  flex: none;
  box-sizing: border-box;
  padding: 12px;
  display: grid;
  place-items: center;
  color: #1f63ea;
  border-radius: 14px;
  background: #edf4ff;
  transition: color 0.25s, background 0.25s;
}

.capability-copy {
  min-width: 0;
  flex: 1;
}

.capability-title {
  margin-bottom: 9px;
  color: #1d1d1d;
  font-size: 21px;
}

.capability-text {
  color: #7d8797;
  font-size: 14px;
  line-height: 22px;
}

.capability-arrow {
  width: 30px;
  height: 30px;
  flex: none;
  display: grid;
  place-items: center;
  color: #8a94a3;
  border-radius: 50%;
  background: #f2f4f7;
  transition: color 0.25s, background 0.25s;

  svg {
    width: 15px;
    height: 15px;
    display: block;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

@media (max-width: 1500px) {
  .grid-layout {
    padding: 0 80px;
    gap: 32px;
  }

  .capability-title {
    font-size: 19px;
  }

  .visual-metrics {
    gap: 12px;
  }

  .metric-value {
    font-size: 22px;
  }
}

@media (max-width: 1100px) {
  .grid-layout {
    padding: 0 24px;
    gap: 22px;
  }

  .capability-item {
    padding: 0 16px;
    gap: 14px;
  }

  .capability-text {
    display: none;
  }
}
</style>
